import React from "react";
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS

import store from "./store";
import App from './App';


// Create a root using createRoot and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
    <ToastContainer />
  </Provider>
);